import { C2bNotificationService } from '../../services';
import types from './types';

const setNotificationsData = (data) => (
    {
        type: types.SET_NOTIFICATIONS,
        data
    }
);

const fetchNotifications = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        C2bNotificationService.fetchNotifications(payload)
            .then(response => {
                resolve(response.data);
                dispatch(setNotificationsData(response?.data));
            }).catch(error => reject(error));
    });
};

const updateNotifications = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        C2bNotificationService.updateNotifications()
            .then(response => {
                resolve(response);
                dispatch(setNotificationsData(response?.data));
            })
            .catch(error => reject(error));
    });
};

export {
    fetchNotifications,
    updateNotifications
};
